import { Component, OnInit } from '@angular/core';
import {LangChange} from '../../../../lang-change';
import {CollegeInfoService} from '../../services/college-info.service';
import {TranslateService} from '@ngx-translate/core';
import {Utils} from '../../../../common/services/Utils';
import {MatDialog} from '@angular/material';
import {Language} from '../../../../common/models/language';
import {SscApplicationService} from '../../../user/services/ssc.application.service';
import {ApplyGovServiceDialogComponent} from './apply-gov-service-dialog/apply-gov-service-dialog.component';
import {ModuleSettingsService} from '../../../admin/services/module-settings.service';

@Component({
  selector: 'app-apply-gos-services',
  templateUrl: './apply-gov-services.component.html',
  styleUrls: ['./apply-gov-services.component.scss']
})
export class ApplyGovServicesComponent extends LangChange implements OnInit {

  colleges: College[];
  collegeInfoMap = new Map();
  langID: string;
  serviceList: any;
  params = {collegeId: 0, search: null, serviceId: -1, iin: ''};
  closedYear = 0;
  hasLicense = false;
  disabled = false;
  constructor(private collegeInfoService: CollegeInfoService,
              _translateService: TranslateService,
              private _utils: Utils,
              private sscService: SscApplicationService,
              private moduleSettingsService: ModuleSettingsService,
              private dialog: MatDialog) {
    super(_translateService);
    this.langID = Language.getCurrentLanguage().code;
  }

  ngOnInit() {
    this.getColleges();
    this.getServices();
  }

  /**
   *  this class function get colleges list
   */
  getColleges() {
    this.collegeInfoService.getColleges(this.langID).subscribe(
      response => {
        this.colleges = response['dictionaryCollege'];
      },
      err => {
        console.log(err);
      }
    );
  }

  getServices(): void {
    this.sscService.getServicesList().subscribe(data => {
      this.serviceList = data;
      this.serviceList.unshift(Language.getFilterObjectNotChosen());
      this.serviceList = this._utils.translateListWithSort(this.serviceList, 'name');
    });
  }

  /**
   * when one of colleges is selected, function gives back some info
   */
  loadCollege() {
    this.disabled = false;
    this.closedYear = 0;
    if (this.params.collegeId) {
      this._utils.blockStart();
      this.collegeInfoService.getCollegeInfoByID(this.params.collegeId, this.langID).subscribe(
        data => {
          this.collegeInfoMap = data['collegeInfoMap'];
          if (this.collegeInfoMap['closed_year']) {
            this.closedYear = this.collegeInfoMap['closed_year'];
            this.disabled = true;
            this._utils.notifySuccess( 'Образовательное учреждение было закрыто в ' + this.closedYear, null);
          } else {
            this.checkModuleLicence();
          }
        },
        err => {
          console.log(err);
        },
        () => {
          this._utils.blockStop();
        }
      );
    }
  }

  checkModuleLicence() {
    this.moduleSettingsService.checkModuleLicense(this.params.collegeId, 'government_services').subscribe(data => {
      this.hasLicense = data;
      if (!this.hasLicense) {
        this.disabled = true;
      }
    });
  }

  sendDocumentsToCollege(collegeInfoMap: any) {
      this.dialog.closeAll();
      const dialogRef = this.dialog.open(ApplyGovServiceDialogComponent, {
        width: '900px',
        height: '650px',
        data: {
          collegeId: this.params.collegeId,
          serviceId: this.params.serviceId,
          iin: this.params.iin
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this._utils.notifySuccess(this._translateService.instant('saved'), null);
        }
      });
  }

  getKeys(map) {
    return Object.keys(map);
  }

  onLangChange(language): void {
    this.langID = language['code'];
    this.ngOnInit();
    this.params.collegeId = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/apply-gov-services/apply-gov-services.component.ts